
import { lazy, Suspense } from "react";
import { usePageTitle } from '@/hooks/usePageTitle';
import { TableSkeleton } from '@/components/ui/skeletons';
import { PageHeader } from '@/components/ui/page-header';
import { PageHeaderActionsProvider } from '@/components/ui/page-header-actions';

const ContactsTable = lazy(
  () => import('@/components/contacts/contacts-table').then(m => ({ default: m.ContactsTable }))
);

function ContactsPage() {
  usePageTitle('Contacts');

  return (
    <PageHeaderActionsProvider>
      <div className="flex flex-col gap-2 flex-1 min-h-0">
        <PageHeader title="Contacts" askAi />
        <ContactsTable />
      </div>
    </PageHeaderActionsProvider>
  );
}

import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/contacts')({
  component: ContactsPage,
  pendingComponent: () => <div className="flex flex-col gap-4 flex-1 min-h-0"><TableSkeleton rows={8} /></div>,
  pendingMs: 0,
  pendingMinMs: 150,
});
